import PHONE from './phone';

const STATES = {
  PHONE,
};

export default STATES;
